import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router/router'
import 'lib-flexible'
import axios from 'axios'
import qs from 'qs';
import waterfall from 'vue-waterfall2'
Vue.use(waterfall)
Vue.use(ElementUI);


Vue.prototype.$axios = axios
 
axios.defaults.baseURL = 'http://fmhd.209.qiyundongli.cn';


axios.interceptors.request.use(function (config) {
let user=''
let user_id='' 
let  token='' 
 if(window.localStorage.getItem('user')!= "undefined"&&window.localStorage.hasOwnProperty('user')){
   user = JSON.parse(window.localStorage.getItem('user'));
   user_id = user.user_id
   token = user.token
 }

    if(config.method === 'post') {
        let data = qs.parse(config.data)

        config.data = qs.stringify({
			user_id:user_id,
            token:token,
			com_id:1210,
			...data
        })
    } else if(config.method === 'get') {
        config.params = {
			user_id:user_id,
            token:token,
			com_id:1210,
			...config.params
        }
    }
    return config;
  }, function (error) {
    return Promise.reject(error);
  })



//axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
// axios.defaults.headers.common['userid'] = 1;
// axios.defaults.headers.common['token'] = 'jaychou';




Vue.config.productionTip = false

new Vue({
    render: h => h(App),
    router
}).$mount('#app')